"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoluntaryExcessHelper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var commonFunctions_1 = require("../../../commonFunctions");
var VoluntaryExcessHelper = /** @class */ (function () {
    function VoluntaryExcessHelper() {
    }
    VoluntaryExcessHelper.renderVoluntaryExcessValues = function (voluntaryExcess) {
        var elements = [];
        for (var index = 0; index <= 500; index += 50) {
            elements.push((0, jsx_runtime_1.jsx)("option", { selected: voluntaryExcess === index, value: index, children: (0, commonFunctions_1.getAmountWithoutDecimalDigits)(index) }));
        }
        return elements;
    };
    return VoluntaryExcessHelper;
}());
exports.VoluntaryExcessHelper = VoluntaryExcessHelper;
//# sourceMappingURL=VoluntaryExcessHelper.js.map